// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (min-width: 699px) and (max-width: 991px) {\r\n   :root {\r\n     --default-size: 10px !important;\r\n  }\r\n}", "",{"version":3,"sources":["webpack://src/components/SignIn/authroot-fontsize.css"],"names":[],"mappings":"AAAA;GACG;KACE,+BAA+B;EAClC;AACF","sourcesContent":["@media screen and (min-width: 699px) and (max-width: 991px) {\r\n   :root {\r\n     --default-size: 10px !important;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
